import React, { useState, useEffect } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import { PPE_getApiSync } from "../../../services/functions"; // Pastikan ini ada
import { getValueFromLocalStorageFunc } from "../../../services/functions";

interface ModalDetailMemberProps {
  showModal: boolean;
  memberId: number;
  onClose: () => void;
}

const ModalDetailMember: React.FC<ModalDetailMemberProps> = ({
  showModal,
  memberId,
  onClose,
}) => {
  const [modalData, setModalData] = useState<any[]>([]); // Array to store multiple members
  const [loading, setLoading] = useState<boolean>(true);

  // Fetch data member berdasarkan ID saat modal terbuka
  useEffect(() => {
    if (showModal && memberId) {
      setLoading(true);
      const token = getValueFromLocalStorageFunc("IOT_TOKEN") ?? "";
      PPE_getApiSync(
        `https://api-kawal.savas.co.id/v1/members/listUserbyIdMember?id_member=${memberId}`,
        null,
        "application/json",
        "GET",
        token,
      )
        .then((response) => {
          console.log("data :", response);
          setModalData(response); // Set response as an array
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          // Handle error fetching data
        });
    }
  }, [showModal, memberId]);

  return (
    <Modal show={showModal} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Detail Member</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div>Loading...</div>
        ) : (
          modalData.length > 0 && (
            <div>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Nama Member</th>
                    <th>Deskripsi</th>
                    <th>Head ID</th>
                    <th>Head Name</th>
                  </tr>
                </thead>
                <tbody>
                  {modalData.map((member, index) => (
                    <tr key={index}>
                      <td>{member.name}</td>
                      <td>{member.description}</td>
                      <td>{member.id_head}</td>
                      <td>{member.name_head}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Tutup
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDetailMember;
